import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create({
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingTop: theme.spacing[4],
    // No background: inherits the host surface (Page or bottom sheet).
    height: 'auto',
  },
  headerWithPaddingHorizontal: {
    paddingHorizontal: theme.spacing[5],
  },
  backButton: {
    marginRight: theme.spacing[4],
  },
  titleContainer: {
    flex: 1,
  },
  spinnerAndCloseButtonContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[6],
  },
  languageButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: theme.spacing[1],
    paddingVertical: theme.spacing[1],
    paddingHorizontal: theme.spacing[2],
  },
});
